import React, { useState, useEffect, useContext } from "react";
import { Grid, Button, Typography } from "@mui/material";
import { serviceProvider } from "../../provider/serviceProvider";
import BlogTabs from "./BlogTabs";
import { useLocation, useNavigate } from "react-router-dom";
import SearchBar from "../../components/searchBar/SearchBar";
import UserContext from "../../context/UserContext";

const BlogsManagement = () => {
  const { pathname } = useLocation();
  const isBlog = pathname.includes("/blogs-management");
  const [searchQuery, setSearchQuery] = useState("");
  const [value, setValue] = React.useState(0);
  const [pageState, setPageState] = React.useState({
    loader: false,
    data: [],
    totalPages: 0,
    page: 0,
    pageSize: 5,
  });

  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const index = searchParams.get("index") || 0;

  // Convert the 'index' value to a number if needed
  const indexNumber = parseInt(index + "", 10);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    navigate(`/${isBlog ? "blogs" : "news"}-management?index=${newValue}`);
  };

  const getBlogsList = (param: any) => {
    // setLoader(true);
    setPageState((prev) => ({ ...prev, loader: true }));

    serviceProvider.blogService
      .get(param)
      .then((res) => {
        // setLoader(false)
        if (res.httpStatus === 200) {
          setPageState((prev) => ({
            ...prev,
            loader: false,
            data: res?.result?.data,
            totalPages: res?.result?.totalRecordCount,
          }));
        }
        setPageState((prev) => ({ ...prev, loader: false }));
      })
      .catch((err) => {
        // setLoader(false)
        setPageState((prev) => ({ ...prev, loader: false }));
        console.log({ err });
      });
  };

  useEffect(() => {
    if (indexNumber) {
      setValue(indexNumber);
    } else {
      setValue(0);
    }
  }, [indexNumber]);
    const context = useContext(UserContext);
const isBlogger =
    context?.authentication?.session?.role[0]?.authority &&
    ["ROLE_BLOGGER:EDIT", "ROLE_BLOGGER:VIEW"].includes(
      context?.authentication?.session.role[0].authority
    );
  useEffect(() => {
    const isActive = (value || indexNumber) === 0 ? true : false;
    const query = `search?uId=NA&categoryId=NA&name=${
      searchQuery || "NA"
    }&tags=NA&content=NA&categoryName=NA&blogpostId=NA&custUrl=NA&offset=${
      pageState.page
    }&limit=${
      pageState.pageSize
    }&order=recordUpdatedTs.desc&profile=BASIC&title=NA&isActive=${isActive}&isFeatured=false&postType=${
      isBlog ? "BLOG" : "NEWS"
    }`;
    getBlogsList(query);
  }, [
    value,
    indexNumber,
    pageState.page,
    pageState.pageSize,
    searchQuery,
    isBlog,
  ]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={5} md={5}>
            <Typography variant="h6" component="h6">
              {isBlog ? "Blogs" : "News"}
            </Typography>
          </Grid>
          <Grid item xs={7}>
            <SearchBar
              value={searchQuery}
              onChange={(e: any) => setSearchQuery(e.target.value)}
              placeholder="Search"
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        {isBlogger ? (
          <Button
            variant="contained"
            className="rounded-btn-fill"
            onClick={() =>
              navigate(`/${isBlog ? "blogs" : "news"}-management/post`)
            }
          >
            
            Add Blog
          </Button>
        ) : <Button
            variant="contained"
            className="rounded-btn-fill"
            onClick={() =>
              navigate(`/${isBlog ? "blogs" : "news"}-management/post`)
            }
          >
            
            Add {isBlog ? "Blog" : "News"}
          </Button>  }
      </Grid>
      <Grid item xs={12}>
        <BlogTabs
          pageState={pageState}
          setPageState={setPageState}
          value={value}
          handleChange={handleChange}
          getBlogsList={getBlogsList}
        />
      </Grid>
    </Grid>
  );
};

export default BlogsManagement;
